import type { FC } from "react"

import styles from "./Badges.module.scss"

// TODO: Known, Unknown Issue 周りのバッジ。component 名雑なので修正

// Log Level Badge
type LogLevelBadgeProps = {
	level: string
}

export const LogLevelBadge: FC<LogLevelBadgeProps> = ({ level }) => {
	const getClassName = (): string => {
		switch (level) {
			case "CRITICAL":
				return styles.levelCritical
			case "ERROR":
				return styles.levelError
			case "WARNING":
				return styles.levelWarning
			default:
				return ""
		}
	}

	return <span className={`${styles.badge} ${getClassName()}`}>{level}</span>
}

// Module Badge
type ModuleBadgeProps = {
	moduleName: string
}

export const ModuleBadge: FC<ModuleBadgeProps> = ({ moduleName }) => {
	const getClassName = (): string => {
		switch (moduleName) {
			case "cancy":
				return styles.moduleCancy
			case "scraping":
				return styles.moduleScraping
			case "nabeko":
				return styles.moduleNabeko
			case "idp":
				return styles.moduleIdp
			case "notiffy":
				return styles.moduleNotiffy
			case "summary":
				return styles.moduleSummary
			case "unknown":
				return styles.moduleUnknown
			case "soppy":
				return styles.moduleSoppy
			case "long_job_executor":
				return styles.moduleLongJobExecutor
			case "fe_event":
				return styles.moduleFeEvent
			case "debug":
				return styles.moduleDebug
			case "unique":
				return styles.moduleUnique
			case "nexus":
				return styles.moduleNexus
			case "publish_worker":
				return styles.modulePublishWorker
			default:
				return styles.moduleDefault
		}
	}

	return (
		<span className={`${styles.badge} ${getClassName()}`}>{moduleName}</span>
	)
}

// Issue Type Badge
type IssueTypeBadgeProps = {
	issueType: string
}

export const IssueTypeBadge: FC<IssueTypeBadgeProps> = ({ issueType }) => {
	const getLabel = (): string => {
		switch (issueType) {
			case "PROGRAMMING_ISSUE":
				return "Prog"
			case "BIZ_TASK":
				return "Biz"
			case "DEV_TASK":
				return "Dev"
			default:
				return issueType
		}
	}

	const getClassName = (): string => {
		switch (issueType) {
			case "PROGRAMMING_ISSUE":
				return styles.typeProg
			case "BIZ_TASK":
				return styles.typeBiz
			case "DEV_TASK":
				return styles.typeDev
			default:
				return ""
		}
	}

	return (
		<span className={`${styles.badge} ${getClassName()}`}>{getLabel()}</span>
	)
}

// OpenSearch Link
type OpenSearchLinkProps = {
	url: string | null | undefined
	title?: string
}

export const OpenSearchLink: FC<OpenSearchLinkProps> = ({
	url,
	title = "OpenSearch で確認",
}) => {
	if (!url) {
		return <span>-</span>
	}

	return (
		<a
			href={url}
			target="_blank"
			rel="noopener noreferrer"
			className={styles.osLink}
			title={title}
		>
			🔗
		</a>
	)
}
